module.exports = __webpack_public_path__ + "img/checkvector.d9cd3105.svg";